// extracted by mini-css-extract-plugin
export default {"linkBigFeedback":"styles_linkBigFeedback__J66lw","bigFeedback":"styles_bigFeedback__+mYn6","content":"styles_content__uQaW8"};